module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("FOREWORD")])]), _c('div', {
    staticClass: "dev"
  }, [_c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-002"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "Illustration. Ed Stetzer, Ph.D.",
      "src": "images/EdStetzer-bw.jpg"
    }
  })]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Ed Stetzer, Ph.D.")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In my work at LifeWay Research and through my blog, I regularly attempt to call the Church’s attention to cultural trends that affect the ways in which we share the gospel and accomplish the Great Commission in our local churches and our personal walks with Christ. I am a missiologist so, well, that’s what we are supposed to help people do.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Whether I’m pointing people to the usefulness of social media or explaining the importance of welcoming other cultures and backgrounds, I serve the Church by helping it better understand and interact with the world around it. One of the most recent trends missiologists have been keeping an eye on is the urbanization of the world and how such migration affects the ways in which we plant churches and do mission.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“The city” is an emerging phrase that seems to be embraced by a growing number of Christians. I intentionally say they are embracing the phrase, because I do not think that all are actually embracing the city. Rather most are simply embracing the idea of embracing the city.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Whatever it is that we say about the city, the truth is the church is often absent from the urban context. Tim Keller, founding pastor of Redeemer Presbyterian Church in New York City and one who is at the forefront of this renewed call to reach the cities, says that people are moving into the cities faster than the church is.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Part of the reason is that urban ministry is complex ministry. A diversity of cultures, races, and socioeconomic statuses make for a beautiful mosaic of the people of God, but working among the diversity of Miami "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("can be more complicated than ministering among a more homogenous group in rural Nebraska.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When cultural differences collide, things can get messy. But the beauty of the gospel is how it brings unity in the midst of what often seems to be chaos. As Paul is writing to the first century churches, most often located in important cities of the day, he constantly brings them back to the unity that belongs to them in Christ—despite all the differences they may see and experience when the church gathers as a body.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("He reminds the Corinthian church that they have all been baptized into one body through one Spirit ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=1%20Corinthians+12%3A12&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("1 Corinthians 12:12")]), _vm._v("). He tells the Galatians that the distinctions so often made in their society—Jew or Greek, slave or free, male or female—were unimportant considering the oneness they had in Christ ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Galatians+3%3A28&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Galatians 3:28")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Paul spent time in these cities and wrote letters to the churches there, not because he felt like rural people didn’t matter, but because he recognized the influence that radiates from the urban centers. It’s why he spent over two years in Ephesus. He was reaching the city, which in turn was reaching the whole province of Asia ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Acts+19%3A10&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Acts 19:10")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So urban ministry is important, and the growing passion for it is encouraging, but if we’re going to properly minister to people in urban areas, we have to better understand modern urbanization and the complexities that make up urban ministry.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I think “God of this City” by Bluetree (popularized by Chris Tomlin) is a great, powerful song that gets at the longing in the hearts of those wanting to do urban ministry—Christians want to embrace, engage, serve, and reach cities. Fair enough. It is a good thing, and something we should be passionate about.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As one who grew up on Long Island outside of New York City and planted my first church in Buffalo, New York among the urban poor, I love the concept of urban ministry.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Yet, I am convinced that you cannot love a city if you do not know a city.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Now, full disclosure, I am biased. I run a research firm and we do city "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("research, so you should be aware of that. I run a research firm because I believe that we need to know so we can engage. If you don’t properly understand the context in which you want to minister until after you start ministering there, your ministry will likely be more frustrating than fruitful.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("That’s where books like "), _c('i', [_vm._v("Serving God in Today’s Cities ")]), _vm._v("come in. This book from Patrick Johnstone and Dean Merrill serves the church by helping its leaders better understand the cities in which they’re planting churches, living on mission, and sharing the gospel.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The fact is, the how of ministry is, in many ways, shaped by the who, when, and where of culture. So, in order to reach the city, we have to come with a missionary mindset. We have to love the city, and know the city, to engage the city.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Serving God in Today’s Cities ")]), _vm._v("can help the church in their effort to develop a missional attitude toward urban areas. But we need to do it now because cities are growing faster than most of us even realize. Patrick Johnstone and Dean Merrill report that by the end of the century, the world will be over 90 percent urban. That is an astonishing statistic. But perhaps more surprisingly, he says we’re already halfway there.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As we go to the cities—not just the idea, but the reality, tools help us to engage them more effectively. I’m thankful for the hard work and in-depth research they put into this book, and my hope is that it will be a useful tool for urban ministers of the gospel for years to come, even as we approach 90 percent urbanization of the world.")]), _c('p', {
    staticClass: "sign"
  }, [_vm._v("Ed Stetzer, Ph.D."), _c('br'), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.edstetzer.com",
      "target": "_blank"
    }
  }, [_vm._v("www.edstetzer.com")])]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 63
// module chunks = 0